import { createContext, useContext } from 'react';

const DropContext = createContext();

export const DropProvider = ({ children, ...otherProps }) => (
  <DropContext.Provider value={otherProps}>{children}</DropContext.Provider>
);

export const useDropContext = () => useContext(DropContext);

export default DropContext;
